import cls from './loader.module.scss';

interface LoaderProps {
  size?: number;
  color?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  size = 16,
  color = '#fff',
}: LoaderProps) => {
  return (
    <svg
      className={cls.spinner}
      width={`${size}px`}
      height={`${size}px`}
      viewBox='0 0 66 66'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        className={cls.path}
        fill='none'
        strokeWidth='6'
        stroke={color}
        strokeLinecap='round'
        cx='33'
        cy='33'
        r='30'
      ></circle>
    </svg>
  );
};
